import { mapState } from 'vuex'
import Vue from 'vue'
import appliesFilters from './applies-filters'
import handleServerErrors from './handle-server-errors'
import fetchResourceScope from './fetch-resource-scope'
import databaseManagement from './database-management'
import authorized from './authorized'

const DATE_FORMAT = 'D MMM YYYY'
const DATE_FORMAT_US = 'MMM D, YYYY'
const DATE_TIME_FORMAT = 'D MMM YYYY hh:mm a'
const DATE_TIME_FORMAT_US = 'MMM D, YYYY hh:mm a'

export {
  appliesFilters,
  handleServerErrors,
  fetchResourceScope,
  authorized,
  databaseManagement,
  DATE_FORMAT,
  DATE_FORMAT_US,
  DATE_TIME_FORMAT,
  DATE_TIME_FORMAT_US
}

Vue.mixin({
  computed: {
    ...mapState('settings', {
      '$settings': 'settings'
    })
  }
})
